import React from 'react';
import { Capacitor } from '@capacitor/core';

const APK_DOWNLOAD_URL = 'https://researcher-setu-api.sarthak-46e.workers.dev/download/app';

export default function ForceUpdateModal({ show, currentBuild, latestBuild }) {
  if (!show) return null;

  const handleUpdate = () => {
    if (Capacitor.isNativePlatform()) {
      // Open in system browser so it downloads outside the app
      window.open(APK_DOWNLOAD_URL, '_system');
    } else {
      window.location.href = APK_DOWNLOAD_URL;
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 999999, padding: 24,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 32, maxWidth: 420,
        textAlign: 'center', fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <h2 style={{ marginTop: 0, fontSize: 24 }}>Update required</h2>
        <p style={{ color: '#444', lineHeight: 1.5 }}>
          A new version of Researcher Setu is required. Tap below to download
          and install the latest version.
        </p>
        <p style={{ color: '#888', fontSize: 12 }}>
          You're on build {currentBuild || '?'}, latest is {latestBuild || '?'}.
        </p>
        <button
          onClick={handleUpdate}
          style={{
            background: '#0d9488', color: '#fff', border: 'none',
            padding: '12px 32px', borderRadius: 8, fontSize: 16,
            fontWeight: 600, cursor: 'pointer', marginTop: 16,
          }}
        >
          Download update
        </button>
      </div>
    </div>
  );
}
